<template>
  <div
    class="product__summary-details flex gap-4 items-center"
  >
    <div class="product__price">
      <ProductPricing
        v-if="fullProductPrice"
        :full-product-price="fullProductPrice"
        :discounted-price="discountedPrice"
        :is-active-product="isActiveProduct"
      />
    </div>
  </div>
</template>

<script lang="ts">

import type { ProductVariant } from '~~/types/commercetools';

export default defineComponent({
  name: 'ProductSummaryDetails',

  props: {
    product: {
      type: Object as PropType<ProductVariant>,
      required: true,
    },
    isActiveProduct: {
      type: Boolean,
      default: false,
    },
  },
  setup(props: { product: ProductVariant }) {

    const { product } = toRefs(props);

    const { getPriceInformation } = useProductPrice();

    const { fullProductPrice, discountedPrice } = getPriceInformation(product);

    return {
      fullProductPrice,
      discountedPrice,
    };

  },
});

</script>
